'use client';

import { BASE_URL } from '@/common/constants';
import { checkType } from '@/common/ultils';
import Link from 'next/link';
import { useRouter } from 'next/navigation';
import { useTranslations } from 'next-intl';

export const revalidate = 300; // Regenerate after 5 minutes

const CategoryNewsBlock = (props) => {
  const { item, websiteCode, titleColor = 'text-red-700', slug, deviceType } = props;

  const router = useRouter();

  const mainPostss = (item?.postss ?? []).slice(0, 2);
  const smallPostss = (item?.postss ?? []).slice(2);

  const t = useTranslations('');

  const handleSubmitUpView = async (id) => {
    try {
      await fetch(`${BASE_URL}/showcaseWalls/updateViews/${id}`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({}),
      });
    } catch {
      // alert(`Có lỗi xảy ra! ${error}`);
    }
  };

  const gotoChuyenMuc = () => {
    router.push(`/${websiteCode ? `sub/${websiteCode}/` : ''}chuyen-muc/${item.slug}`);
  };

  return (
    <div className="mb-6 p-3 border border-gray-200 rounded  bg-white">
      <h3
        onClick={() => {
          gotoChuyenMuc();
          handleSubmitUpView(item?.id);
        }}
        className={`text-base font-bold ${titleColor} mb-3 pb-2 border-b 
        border-gray-300 flex items-center uppercase cursor-pointer`}>
        {item?.name}
      </h3>

      <div className="flex justify-between gap-4 mb-5">
        {mainPostss.map((item) => {
          return (
            <div className="flex justify-between flex-col items-start  w-1/2" key={item.id}>
              <Link href={websiteCode ? `/sub/${websiteCode}/${slug}/${item.slug}` : `/${slug}/${item.slug}`} className="mr-3 w-full ">
                {item?.imgaeUrls ? (
                  <div className="bg-gray-100 mb-2 rounded flex items-center justify-center  text-gray-500 text-sm aspect-video overflow-hidden">
                    <img src={checkType(deviceType, item)} alt={item.title} className="rounded  object-cover w-full h-auto" />
                  </div>
                ) : (
                  <div className="bg-gray-100 mb-2 rounded flex items-center justify-center py-3 text-gray-500 text-sm aspect-video">
                    <img src={`/img-default.png`} alt="Ảnh mặc định" className="rounded mb-2 object-cover w-12.5 h-12.5" />
                  </div>
                )}
              </Link>

              <div className="flex-1">
                <Link href={websiteCode ? `/sub/${websiteCode}/${slug}/${item.slug}` : `/${slug}/${item.slug}`} className="group">
                  <p className="font-semibold text-base group-hover:text-red-600 line-clamp-2">{item.title}</p>
                </Link>
              </div>
            </div>
          );
        })}
      </div>

      <div>
        {smallPostss.length > 0 && (
          <ul className="space-y-2 flex-grow sm:mt-0 list-none pl-0 !mt-3">
            {smallPostss.map((article) => (
              <li key={article.id} className="text-[13px] text-gray-600 leading-tight flex items-start pb-1 border-b border-dotted border-gray-300">
                <span className="text-red-600 mr-2  text-xs">■</span>
                <Link
                  href={websiteCode ? `/sub/${websiteCode}/${slug}/${article.slug}` : `/${slug}/${article.slug}`}
                  className="hover:text-red-600 hover:underline line-clamp-1">
                  {article.title}
                </Link>
              </li>
            ))}
          </ul>
        )}
      </div>
      {smallPostss.length === 8 && (
        <button
          className="text-red-600 w-full text-sm mt-3 flex justify-end
       cursor-pointer"
          onClick={() => {
            gotoChuyenMuc();
            handleSubmitUpView(item?.id);
          }}>
          {t('news.viewAll')} &gt;&gt;
        </button>
      )}
    </div>
  );
};

export default CategoryNewsBlock;
